export function resultTone(value) {
  if (value==='对子') return 'result-cyan';
  if (value==='和') return 'result-purple';
  if (value==='顺子') return 'result-purple';
  if (value==='豹子') return 'result-orange';
  if (value==='极大') return 'result-orange';
  if (value==='极小') return 'result-purple';
  if (value==='大'||value==='双'||value==='龙') return 'result-red';
  if (value==='小'||value==='单'||value==='虎') return 'result-blue';
  return '';
}
export function ResultText({value}) {
  if (/^[大小][单双]$/.test(value)) return <span className="result-label result-combination">{[...value].map((part,i)=><span className={`result-part ${resultTone(part)}`} key={i}>{part}</span>)}</span>;
  const tone=resultTone(value);
  return <span className={tone?`result-label ${tone}`:''}>{value}</span>;
}
